import { useAuthStore } from "@/state/pinia";

export default [
  // ===== Default → przegląd usług aktywnego workspace'u =====
  {
    path: "/",
    name: "default",
    meta: { title: "Usługi", authRequired: true },
    redirect: { name: "services.dashboard" },
  },

  // ===== Auth =====
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        const auth = useAuthStore();
        if (auth.getToken && auth.getToken()) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    name: "logout",
    meta: { title: "Logout", authRequired: true },
    component: () => import("@/views/account/logout.vue"),
  },
  {
    path: "/auth/callback",
    name: "sso-callback",
    component: () => import("@/views/account/sso-callback.vue"),
    meta: { title: "SSO Login", guestOnly: true },
  },

  // ===== Workspaces =====
  {
    path: "/workspaces/new",
    name: "workspaces.create",
    meta: { title: "Create workspace", authRequired: true, workspaceLevel: true },
    component: () => import("@/views/workspaces/CreateNew.vue"),
  },
  {
    path: "/workspaces",
    name: "workspaces.select",
    meta: { title: "Select workspace", authRequired: true, workspaceLevel: true },
    component: () => import("@/views/workspaces/Select.vue"),
  },
  {
    path: "/workspaces/:workspace_uuid/settings",
    name: "workspaces.settings",
    meta: { title: "Workspace settings", authRequired: true, workspaceLevel: true },
    component: () => import("@/views/workspaces/SettingsView.vue"),
  },

  // ===== Usługi =====
  {
    path: "/services",
    name: "services.dashboard",
    meta: { title: "Usługi", authRequired: true },
    component: () => import("@/views/services/ServicesDashboard.vue"),
  },
  {
    path: "/domains",
    name: "services.domains",
    meta: { title: "Domeny", authRequired: true },
    component: () => import("@/views/services/DomainsView.vue"),
  },
  {
    path: "/domains/:uuid",
    name: "services.domain",
    meta: { title: "Domena", authRequired: true },
    component: () => import("@/views/services/DomainDetail.vue"),
  },
  {
    path: "/mail",
    name: "services.mail",
    meta: { title: "Poczta", authRequired: true },
    component: () => import("@/views/services/MailView.vue"),
  },
  {
    path: "/hosting",
    name: "services.hosting",
    meta: { title: "Hosting", authRequired: true },
    component: () => import("@/views/services/HostingView.vue"),
  },
  {
    path: "/hosting/:uuid",
    name: "services.hosting.detail",
    meta: { title: "Hosting", authRequired: true },
    component: () => import("@/views/services/HostingDetail.vue"),
  },
  {
    path: "/ssl",
    name: "services.ssl",
    meta: { title: "SSL", authRequired: true },
    component: () => import("@/views/services/SslView.vue"),
  },
  {
    path: "/ssl/:uuid",
    name: "services.ssl.detail",
    meta: { title: "SSL", authRequired: true },
    component: () => import("@/views/services/SslDetail.vue"),
  },

  // ===== Billing =====
  {
    path: "/billing",
    name: "billing.plans",
    meta: { title: "Rozliczenia", authRequired: true, workspaceLevel: true },
    // Zakładki workspace'u jak w LessCMS/Commerce; faktury w panelu SSO.
    component: () => import("@/views/workspaces/BillingView.vue"),
  },

  // Użytkownicy żyją w ustawieniach workspace'u (stare linki).
  {
    path: "/users",
    name: "users.list",
    redirect: () => ({ name: "workspaces.settings", params: { workspace_uuid: localStorage.getItem("activeWorkspace") || "-" }, query: { section: "users" } }),
  },

  // ===== Fallback =====
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "default" },
  },
];
